import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { IAltenarState } from '../types'

export default combineReducers<IAltenarState['communications']>({
  getSportToken: makeCommunicationReducer(actions.getSportToken),
})
